import { Box, Container, List, ListItem, Paper } from "@mui/material";
import { useCallback } from "react";
import AboutYou from "./AboutYou/AboutYou";
import UserCard from "./UserCard";
import { t } from "@lingui/macro";
import {
  ErrorBoundary,
  GlobalHeader,
  PullToRefresh,
  useUserContext,
} from "@WahooFitness/wahoo-offline-mfe";

const User = () => {
  const { currentUser, userIsLoading, userError, mutateUser } = useUserContext();

  const handleReload = useCallback(() => {
    mutateUser();
  }, [mutateUser]);

  return (
    <>
      <PullToRefresh onRefresh={handleReload} />
      <GlobalHeader title={t`Profile`} />
      <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
        <ErrorBoundary error={userError} isLoading={userIsLoading} onReload={handleReload}>
          {currentUser && (
            <Box p={2}>
              <List disablePadding component={Box} display="flex" flexDirection="column" gap={1}>
                <ListItem component={Paper} sx={{ p: 2 }}>
                  <Box display="flex" flexDirection="column" gap={4} width="100%">
                    <UserCard user={currentUser} />
                    <AboutYou user={currentUser} />
                  </Box>
                </ListItem>
              </List>
            </Box>
          )}
        </ErrorBoundary>
      </Container>
    </>
  );
};

export default User;
